import styled from 'styled-components';

import { screen } from '../../variables';

export default function Container(props) {
  const {
    backgroundColor,
    backgroundImage,
    children,
    color,
    height,
    id,
    noPaddingOnMobile,
    style,
    className,
  } = props;

  return (
    <StyledContainer
      id={id}
      backgroundColor={backgroundColor}
      backgroundImage={backgroundImage}
      color={color}
      height={height}
      noPaddingOnMobile={noPaddingOnMobile}
      style={style}
      className={className}
    >
      {children}
    </StyledContainer>
  );
}

const StyledContainer = styled.section`
  box-sizing: border-box;
  background-color: ${(props) => props.backgroundColor || '#fff'};
  background-image: ${(props) => `url(${props.backgroundImage})` || 'none'};
  background-size: cover;
  background-position: center;
  color: ${(props) => props.color || '#464949'};
  width: 100%;
  height: ${(props) => props.height || 'auto'};
  display: flex;
  flex-direction: column;
  padding: 0 18px;

  @media (max-width: ${screen.tablet}px) {
    padding: ${(props) => props.noPaddingOnMobile && '0'};
  }
`;
